export const MIN_USERNAME_LENGTH = 3;
export const MAX_USERNAME_LENGTH = 12;
export const MAX_GUEST_USERNAME_LENGTH = 6;
